"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.poll = exports.isJSON = exports.noop = exports.sleep = void 0;
/**
 * @param ms the number of milliseconds to sleep
 * @returns a promise that resolves after the given number of milliseconds
 */
const sleep = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
};
exports.sleep = sleep;
/**
 * @dev used to do a no-op without having to override eslint/ts rules about empty functions
 * @returns void
 */
const noop = () => {
    return;
};
exports.noop = noop;
/**
 * @param str the string to check
 * @returns true if the string is a valid JSON
 */
function isJSON(str) {
    try {
        JSON.parse(str);
    }
    catch (e) {
        return false;
    }
    return true;
}
exports.isJSON = isJSON;
/**
 * Allows to poll a function until it returns a valid result, fully typed.
 *
 * @param pollConfig the configuration for the poll
 * @returns a promise that resolves when the pollConfig.validate function returns true
 * @dev the pollConfig.fetch function is called every pollConfig.interval milliseconds
 */
const poll = (pollConfig) => {
    let attempts = 0;
    const executePoll = (resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        let result;
        try {
            result = yield pollConfig.fetch();
        }
        catch (e) {
            return reject(new Error(pollConfig.errorMessage));
        }
        attempts++;
        if (pollConfig.validate(result)) {
            return resolve(result);
        }
        else if (pollConfig.maxAttempts && attempts === pollConfig.maxAttempts) {
            return reject(new Error(pollConfig.errorMessage));
        }
        else {
            setTimeout(executePoll, pollConfig.interval, resolve, reject);
        }
    });
    return new Promise(executePoll);
};
exports.poll = poll;
//# sourceMappingURL=misc.js.map